export default __webpack_public_path__ + "static/media/EN_10.beb80313.svg";